import React from 'react';
import { View } from '@24i/nxg-sdk-quarks';
import Loader from '@24i/nxg-sdk-gluons/src/components/ui/Loader';
import { loaderStyle, webViewLoaderStyle } from './styles';

const AuthView = () => (
    <View style={webViewLoaderStyle}>
        <Loader additionalStyles={loaderStyle} color="white" size="large" />
    </View>
);

export default AuthView;
